var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single__header"},[_c('div',{staticClass:"back"},[_c('a',{on:{"click":function($event){return _vm.goBack()}}},[_c('img',{attrs:{"src":_vm.back_icon,"alt":"back"}})])]),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('h3',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/SingleHeader.vue?vue&type=template&id=1008f142&scoped=true&
// module id = 333
// module chunks = 0